/**
 * Screen Saver Software OTA control model (APK plane — not content).
 * Installed must be device-confirmed; Available is staging approved artifact.
 *
 * Shared inventory compare/display lives in softwareInventoryModel.
 */

import {
  SCREENSAVER_PACKAGE_NAME,
  displaySoftwareVersion,
  isSoftwareUpdateAvailable,
  isSoftwareUpToDate,
} from "@/features/devices/softwareInventoryModel";

export { SCREENSAVER_PACKAGE_NAME };

export type ScreensaverPackageIdentity = {
  versionCode: number;
  versionName: string;
  displayVersion?: string | null;
};

export const displayScreensaverSoftwareVersion = displaySoftwareVersion;

export function isScreensaverSoftwareUpdateAvailable(args: {
  installedVersionCode?: number | null;
  availableVersionCode?: number | null;
}): boolean {
  return isSoftwareUpdateAvailable(args);
}

export function isScreensaverSoftwareUpToDate(args: {
  installedVersionCode?: number | null;
  availableVersionCode?: number | null;
}): boolean {
  return isSoftwareUpToDate(args);
}

/** Exact Fleet command body for Screensaver APK OTA — reuses update_kk_package. */
export function buildScreensaverPackageUpdateBody(): {
  command: "update_kk_package";
  packageName: typeof SCREENSAVER_PACKAGE_NAME;
} {
  return {
    command: "update_kk_package",
    packageName: SCREENSAVER_PACKAGE_NAME,
  };
}
